import { render, staticRenderFns } from "./insert_sightseeing.vue?vue&type=template&id=517876c7&scoped=true"
import script from "./insert_sightseeing.vue?vue&type=script&lang=js"
export * from "./insert_sightseeing.vue?vue&type=script&lang=js"
import style0 from "./insert_sightseeing.vue?vue&type=style&index=0&id=517876c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517876c7",
  null
  
)

export default component.exports